import { useTranslation } from 'next-i18next';
import { useEffect, useMemo, useState } from 'react';

import { ButtonV3 } from 'components/ComponentV2';
import { USERINFO_LABELS } from 'hooks/useCandidateProfile';
import { useCandidateProfile } from 'lib/contexts/candidate-profile-context';
import { AccomplishmentResponseAttributes } from 'lib/models/candidate';
import { useAuth } from 'lib/providers/AuthProvider';

import EmptyBottomSection from '../EmptyBottomSection';
import TopTitleBar from '../TopTitleBar';
import { getSkillsInfo } from './utils';
import { AddSkillsModal } from './AddSkillsModal.component';
import DisplaySkills from './DisplaySkills';

import styles from './Skills.module.scss';

export const Skills = ({ className }: { className?: string }) => {
  const { candidate } = useAuth();

  const [accomplishmentsInfo, setAccomplishmentsInfo] = useState<
    (AccomplishmentResponseAttributes & {
      isNew: boolean;
    })[]
  >([]);

  useEffect(() => {
    if (candidate) {
      setAccomplishmentsInfo(getSkillsInfo(candidate));
    }
  }, [candidate]);
  const { userInfoStatus } = useCandidateProfile();
  const [t] = useTranslation('candidate.profile');
  const [tm] = useTranslation('candidate.profile.modal');

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const accomplishmentsComplete = userInfoStatus.some(
    (status) => status.label === USERINFO_LABELS.SKILLS && status.completed
  );
  const openModal = () => {
    setIsModalOpen(true);
  };

  const accomplishmentExist = useMemo(() => {
    let accomplishmentExist = false;
    const getAllType = [
      tm('skills.dropdown-options.skills'),
      tm('skills.dropdown-options.achievements'),
      tm('skills.dropdown-options.interests'),
    ];
    if (accomplishmentsInfo.length === 0) {
      accomplishmentExist = false;
    }
    const accomplishments = accomplishmentsInfo.filter((item) =>
      getAllType.includes(item.title)
    );
    accomplishments.forEach((item) => {
      if (item.values.length > 0) {
        accomplishmentExist = true;
      }
    });

    return accomplishmentExist;
  }, [accomplishmentsInfo]);

  return (
    <article className={className}>
      <TopTitleBar
        title={t('skills.title')}
        isInfoComplete={accomplishmentsComplete}
        iconName="icon_plus"
        onIconClick={openModal}
      />
      {accomplishmentExist ? (
        <section className={styles['skills-container']}>
          <DisplaySkills isEdit={false} openModal={openModal} />
          <ButtonV3
            onClick={openModal}
            startIcon="icon_plus"
            size="small"
            color="secondary"
          >
            {t('skills.button-text')}{' '}
          </ButtonV3>
        </section>
      ) : (
        <EmptyBottomSection
          desc={t('skills.desc')}
          addButtonText={t('skills.button-text')}
          createWithAIButton={false}
          onAddIconClick={openModal}
        />
      )}
      <AddSkillsModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      />
    </article>
  );
};
